import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import {Link} from 'gatsby'

import logoImg from '../../../../static/images/header-mobile/menu/images/logo.svg'
import cancelImg from '../../../../static/images/header-mobile/menu/images/cancel.svg'
import twitterImg from '../../../../static/images/header-mobile/menu/images/twitter.svg'
import linkedinImg from '../../../../static/images/header-mobile/menu/images/linkedin.svg'

const Menu = ({path, display, click, setDisplay}) => {

    useEffect(() => {
        document.getElementsByClassName('slidein').style = "@-webkit-keyframes slidein {0% {left: 100%;, webkit-transform: scaleX(0);}100% {left: 0;, webkit-transform: scaleX(1);}}"
        document.getElementsByClassName('slideout').style = "@-webkit-keyframes slideout {from {display : block;left: 0;}to {left: 100%;, webkit-transform: scaleX(1);display : none;}}"
    })

    const dismissMenu = (path, link) => {
        if (path === link) {
            setDisplay(false)
        }
    }

    return (
        <MenuWrapper>
            <MenuStyle className={`${display && click ? 'slidein' : !display && click ? 'slideout' : 'hidden'}`}>
                <HeaderStyle>
                    <Link to={'/'}>
                        <LogoStyle></LogoStyle>
                    </Link>
                    <CancelStyle onClick={() => setDisplay(false)}></CancelStyle>
                </HeaderStyle>
                <NavStyle>
                    <ListStyle>
                        <ElemStyle onClick={() => dismissMenu(path, '/who-we-are/')}>
                            {path !== '/who-we-are/' ?
                                <Link to={'/who-we-are/'}
                                         className={`link ${path === '/who-we-are/' ? 'active' : path === '/' ? 'white' : ''}`}><span>Who we are</span></Link> :
                                <span className={'active'}>Who we are</span> }
                            </ElemStyle>
                        <ElemStyle onClick={() => dismissMenu(path, '/sectors/')}>
                            {path !== '/sectors/' ?
                                <Link to={'/sectors/'}
                                         className={`link ${path === '/sectors/' ? 'active' : path === '/' ? 'white' : ''}`}>
                            <span>Where we focus</span></Link> :
                                <span className={'active'}>Where we focus</span> }
                        </ElemStyle>
                        <ElemStyle onClick={() => dismissMenu(path, '/what-we-build/')}>
                            {path !== '/what-we-build/' ?
                                <Link to={'/what-we-build/'}
                                         className={`link ${path === '/what-we-build/' ? 'active' : path === '/' ? 'white' : ''}`}><span>What we build</span></Link> :
                                <span className={'active'}>What we build</span> }
                            </ElemStyle>
                        <ElemStyle onClick={() => dismissMenu(path, '/contact-us/')}>
                            {path !== '/contact-us/' ?
                                <Link to={'/contact-us/'}
                                         className={`link ${path === '/contact-us/' ? 'active' : path === '/' ? 'white' : ''}`}><span>How to connect</span></Link>:
                                <span className={'active'}>How to connect</span> }
                            </ElemStyle>
                    </ListStyle>
                </NavStyle>
                <SocialsStyle>
                    <a href="https://twitter.com/MedadTech"><TwitterImage></TwitterImage></a>
                    <a href="https://www.linkedin.com/company/medad-technology"><LinkedinImage></LinkedinImage></a>
                </SocialsStyle>
            </MenuStyle>
        </MenuWrapper>
    )
}

export default Menu

const MenuStyle = styled.div`
  height: 100vh;
  position: fixed;
  width: 100%;
  overflow-y: hidden;
  z-index: 5;
  background-color: ${({theme}) => theme.colors.secondary};
`

const HeaderStyle = styled.div`
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  padding: 1.6rem 2.4rem;
  display: flex;
  justify-content: space-between;
`

const LogoStyle = styled.div`
  width: 4.4rem;
  height: 2.47rem;
  background-image: url(${logoImg});
  background-repeat: no-repeat;
  background-size: contain;
`

const CancelStyle = styled.div`
  //text-decoration: none;
  //border: none;
  width: 2.4rem;
  height: 2.4rem;
  background-image: url(${cancelImg});
  background-repeat: no-repeat;
  background-size: contain;
`

const NavStyle = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ListStyle = styled.ul`
  list-style: none;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.1rem;
`

const ElemStyle = styled.li`
  .link {
    color: #ffffff;
    opacity: .6;
  }
  
  .white {
      opacity: 1;
  }

  .active {
    opacity: 1;
    padding: 1.5rem 0;
    color: ${({theme}) => theme.colors.white};
    position: relative;
    width: fit-content;
    font-size: 1.8rem;
  }
  .active:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 3px;
      bottom: 0;
      left: 0;
      background: ${({theme}) => theme.colors.white};
      visibility: visible;
      transform: scaleX(1);
      transition: .25s linear;
    }
`

const SocialsStyle = styled.div`
  position: absolute;
  bottom: 10.6rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  gap: .8rem;
`

const TwitterImage = styled.div`
  background-image: url(${twitterImg});
  background-repeat: no-repeat;
  background-size: contain;
  width: 3.8rem;
  height: 3.8rem;
`

const LinkedinImage = styled.div`
  background-image: url(${linkedinImg});
  background-repeat: no-repeat;
  background-size: contain;
  width: 3.8rem;
  height: 3.8rem;
`

const MenuWrapper = styled.div`
  .slidein {
    display : block;
    animation: slidein .6s;
    -moz-animation: slidein .6s; /* Firefox */
    -webkit-animation: slidein .6s; /* Safari and Chrome */
    -o-animation: slidein .6s; /* Opera */

    @keyframes slidein {
      0% {
        left: 100%;
        , webkit-transform: scaleX(0);
      }
      100% {
        left: 0;
      , webkit-transform: scaleX(1);

      }
    }
    @-moz-keyframes slidein { /* Firefox */
      0% {
        left: 100%;
                , webkit-transform: scaleX(0);

      }
      100% {
        left: 0;
      , webkit-transform: scaleX(1);

      } }
    //@-webkit-keyframes slidein { /* Safari and Chrome */
    //  0% {
    //    left: 100%;
    //            , webkit-transform: scaleX(0);
    //  }
    //  100% {
    //    left: 0;
    //  , webkit-transform: scaleX(1);
    //  }
    //}
    @-o-keyframes slidein { /* Opera */
      0% {
        left: 100%;
      }
      100% {
        left: 0;
      // , webkit-transform: scaleX(1);

      }
    }
  }

  .hidden {
    display : none;
  }

  .slideout {
    animation: slideout .6s;
    -moz-animation: slideout .6s; /* Firefox */
    -webkit-animation: slideout .6s; /* Safari and Chrome */
    -o-animation: slideout .6s; /* Opera */
    left: 100%;
    @keyframes slideout {
      from {
        display : block;
        left: 0;
      }
      to {
        left: 100%;
      , webkit-transform: scaleX(1);
        display : none;
      }
    }
    @-moz-keyframes slideout { /* Firefox */
      from {
        display : block;
        left: 0;
      }
      to {
        left: 100%;
      , webkit-transform: scaleX(1);
        display : none;
      }
    }
    //@-webkit-keyframes slideout { /* Safari and Chrome */
    //  from {
    //    display : block;
    //    left: 0;
    //  }
    //  to {
    //    left: 100%;
    //  , webkit-transform: scaleX(1);
    //    display : none;
    //  }
    //}
    @-o-keyframes slideout { /* Opera */
      from {
        display : block;
        left: 0;
      }
      to {
        left: 100%;
      , webkit-transform: scaleX(1);
        display : none;
      }
    }
  }`
